import { Component } from '@verndale/core';
import { nanoid } from 'nanoid';
import { createFocusTrap } from 'focus-trap';
import keys from '../utils/keys';
import { setAriaLabelledBy } from '../utils/dom';

class SubpageNav extends Component {
  setupDefaults() {
    this.dom = {
      $heading: this.el._$('.subpage-nav__heading'),
      $content: this.el._$('.subpage-nav__content'),
      $mobileNav: document._$('.subpage-nav--mobile')
    };

    this.currentViewport = null;
    this.setXsViewportDom();
    this.labelNavs();
    if (this.dom.$mobileNav)
      this.navFocusTrap = createFocusTrap(this.dom.$mobileNav, {
        escapeDeactivates: false
      });
  }

  addListeners() {
    const { $mobileNav } = this.dom;

    $mobileNav?._$('.subpage-nav__heading')._on('click', ::this.handleClick);
    $mobileNav?._on('keydown', ::this.handleKeydown);
  }

  handleKeydown(e) {
    const $heading = e.currentTarget._$('.subpage-nav__heading');
    const $button = e.currentTarget._$('.subpage-nav__heading-button');

    if (e.keyCode === keys.escape && $button && $heading) {
      this.navFocusTrap.deactivate();
      $heading.classList.add('subpage-nav__heading--closed');
      $button.setAttribute('aria-expanded', 'false');
    }
  }

  handleClick({ target }) {
    const $heading = target.closest('.subpage-nav__heading');
    const $button = target.closest('.subpage-nav__heading-button');

    if ($button && this.navFocusTrap) {
      const isOpen = $button.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        this.navFocusTrap.deactivate();
        $heading.classList.add('subpage-nav__heading--closed');
        $button.setAttribute('aria-expanded', 'false');
      } else {
        this.navFocusTrap.activate();
        $heading.classList.remove('subpage-nav__heading--closed');
        $button.setAttribute('aria-expanded', 'true');
      }
    }
  }

  setXsViewportDom() {
    const { $content, $heading, $mobileNav } = this.dom;
    if (!$mobileNav) return;

    const $parentContainer = $mobileNav.parentElement;
    const $mobileHeading = $heading.cloneNode(true);
    const $mobileContent = $content.cloneNode(true);
    const $title = $mobileHeading._$('span');
    $title.classList.add('subpage-nav--mobile__heading-title');

    $parentContainer.insertBefore($title, $mobileNav);
    $mobileNav.appendChild($mobileHeading);

    const contentId = `id-${nanoid()}`;
    const buttonId = `id-${nanoid()}`;
    const $button = document.createElement('button');
    const $icon = `
        <svg class="subpage-nav__heading-icon">
          <use xlink:href="#chevron-down-outline" />
        </svg>
      `;
    const activeElement = `<span>${
      this.el._$('.subpage-nav__item--active')?.textContent ||
      $heading?.textContent
    }</span>`;


    $mobileNav.appendChild($mobileContent);

    $mobileHeading.classList.add('subpage-nav__heading--closed');
    $mobileHeading.appendChild($button);
    $button.classList.add('subpage-nav__heading-button');
    $button.insertAdjacentHTML('afterbegin', activeElement);

    $button.insertAdjacentHTML('beforeend', $icon);
    $button.id = buttonId;
    $button.setAttribute('aria-expanded', 'false');
    $button.setAttribute('aria-controls', contentId);
    $mobileContent.id = contentId;
    $mobileContent.setAttribute('role', 'region');
    $mobileContent.setAttribute('aria-labelledby', buttonId);
  }

  labelNavs() {
    const { $mobileNav, $heading } = this.dom;
    setAriaLabelledBy(this.el, $heading);

    if (!$mobileNav) return;
    const $mobileTitle = $mobileNav._$('.subpage-nav__heading');
    setAriaLabelledBy($mobileNav, $mobileTitle);
  }
}

export default SubpageNav;
